import {AgencyRepository} from "../../../repositories/AgencyRepository.ts";
import {AgencyUser, CreateAgencyUserPasswordRequest} from "../../entities/AgencyUser.ts";

export class CreateAgencyUserWithPasswordUseCase {
    constructor(private readonly agencyRepository: AgencyRepository) {}

    async execute(agencyId: string, data: CreateAgencyUserPasswordRequest): Promise<AgencyUser> {
        return this.agencyRepository.createAgencyUserWithPassword(agencyId, data)
    }
}
